module.exports = __webpack_public_path__ + "static/media/return.7586ae09.md";